import { useMemo } from 'react';

import { useRootDocument } from '~/core/shared/hooks';
import { getDocumentTargetAndLocationForPath } from '~/core/shared/utils';
import { DocumentDataViewProps } from '../../types/DocumentDataViewProps';

export const useDocumentDataView = <DocumentDefinition>(
  documentPath: Exclude<
    DocumentDataViewProps<DocumentDefinition>['documentPath'],
    undefined
  >,
) => {
  const rootDocument = useRootDocument();
  const [documentTarget] = useMemo(
    () => getDocumentTargetAndLocationForPath(rootDocument, documentPath),
    [rootDocument, documentPath],
  );
  const hasMany = useMemo(
    () => Array.isArray(documentTarget),
    [documentTarget],
  );

  return {
    documentTarget,
    hasMany,
  };
};
